module.exports = __webpack_public_path__ + "static/media/bg-squiggle.c77a357e.png";